import {
  ChakraBox as Box,
  ChakraFlex as Flex,
  ChakraStack as Stack,
  ChakraText as Text,
} from "@airhelp/react-ui-components";
import { Container } from "components/Container";
import { useTranslations } from "contexts/LocalizationContext";
import { Grid } from "modules/common/components/Grid";
// TODO | Remove once all the data is migrated
import PlanBox from "modules/common/components/PlanBox";
import { useEffect } from "react";
import type { SbEditableComponentProps } from "types/storyblok";
import { trackEcommerceEvent } from "utils/tracking";
import type { AhPlusPricingPlansProps } from "./AhPlusPricingPlans.d";
import { PRICING_PLANS_ANCHOR, usePricingPlanDetailsConfig } from "./config";
import { CHOOSE_PRODUCT_COMPLETE_EVENT_UA, CHOOSE_PRODUCT_ESSENTIAL_EVENT_UA } from "./trackingConsts";
import { useGetSelectItemTrackingEvent, useGetViewItemTrackingEvent } from "./trackingUtils";
import { PlanBox as NewPlanBox } from "./PlanBox/PlanBox";

export const AhPlusPricingPlans = ({
  bottomText,
  horizontalPaddingDesktop,
  horizontalPaddingMobile,
  verticalPaddingDesktop,
  verticalPaddingMobile,
  sbEditable,
  cards,
}: SbEditableComponentProps<AhPlusPricingPlansProps>) => {
  const viewItemTrackingEvent = useGetViewItemTrackingEvent();

  // TODO | Remove once all the data is migrated
  const selectItemTrackingEventEssential = useGetSelectItemTrackingEvent("essential");
  const selectItemTrackingEventComplete = useGetSelectItemTrackingEvent("complete");
  const translations = useTranslations();
  const plansConfig = usePricingPlanDetailsConfig();
  const { essential: essentialPlan, complete: completePlan } = plansConfig;

  useEffect(() => {
    trackEcommerceEvent(viewItemTrackingEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO | Remove once all the data is migrated
  const isNewAhPlusPricingPlans =
    bottomText &&
    horizontalPaddingDesktop &&
    horizontalPaddingMobile &&
    verticalPaddingDesktop &&
    verticalPaddingMobile &&
    Boolean(cards);

  const newAhPlusPricingPlans = (
    <Box
      {...sbEditable}
      bg="primary.900"
      id={PRICING_PLANS_ANCHOR}
      py={{ base: verticalPaddingMobile, lg: verticalPaddingDesktop }}
      px={{ base: horizontalPaddingMobile, lg: horizontalPaddingDesktop }}
    >
      <Container>
        <Stack
          spacing={{ base: 8, md: 4, lg: 8 }}
          direction={{ base: "column", md: "row" }}
          justify="center"
          align="stretch"
        >
          {cards?.map(({ content, planType }) => (
            <NewPlanBox key={planType} content={content} planType={planType} />
          ))}
        </Stack>
        <Text px={8} color="white" fontSize="md" textAlign="center" mt={{ base: 12, md: 10 }}>
          {bottomText}
        </Text>
      </Container>
    </Box>
  );

  // TODO | Remove once all the data is migrated
  const oldAhPlusPricingPlans = (
    <Box bg="primary.900" py={{ base: 10, sm: 20 }} id={PRICING_PLANS_ANCHOR}>
      <Grid mb={0}>
        <Flex gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
          <Flex
            flexDir={{ base: "column", md: "row" }}
            justify="center"
            align={{ base: "center", md: "stretch" }}
            gap={{ base: 12, md: "initial" }}
          >
            {/* @ts-ignore */}
            <PlanBox
              planDetails={essentialPlan}
              gaEvent={selectItemTrackingEventEssential}
              uaEvent={CHOOSE_PRODUCT_ESSENTIAL_EVENT_UA}
            />
            {/* @ts-ignore */}
            <PlanBox
              planDetails={completePlan}
              gaEvent={selectItemTrackingEventComplete}
              uaEvent={CHOOSE_PRODUCT_COMPLETE_EVENT_UA}
            />
          </Flex>
          <Text px={8} color="white" fontSize="lg" textAlign="center" mt={{ base: 12, md: 16 }}>
            {translations("plan_no_matter_where_you_flying")}
          </Text>
        </Flex>
      </Grid>
    </Box>
  );

  return isNewAhPlusPricingPlans ? newAhPlusPricingPlans : oldAhPlusPricingPlans;
};
